import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_communicate_improvement_plans_to_interested_stakeh'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_communicate_improvement_plans_to_interested_stakeh',
  name: 'Does the facility communicate improvement plans to interested stakeholders?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'SENIOR_MANAGEMENT',
      text: 'Senior management',
      externalIds: [
        {
          id: 'ms-7--1-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS',
      text: 'Workers',
      externalIds: [
        {
          id: 'ms-7--1-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'CUSTOMERS',
      text: 'Customers',
      externalIds: [
        {
          id: 'ms-7--1-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-7--1-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-7--1-4f',
            version: '1.3',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: ['SENIOR_MANAGEMENT', 'WORKERS', 'CUSTOMERS', 'OTHER'],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-act-2',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 23880,
  sectionId: '2.2.6.12',
  impactArea: 'Management Systems',
  impactAreaId: 'MANAGEMENT_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
